import { useState } from 'react';

export const useHighlight = () => {
  const [isHighlight, setIsHighlight] = useState(false);

  const highlightElement = (targetID: string) => {
    const elem = document.getElementById(targetID);
    if (elem) {
      elem.classList.add('highlightActive');
      elem.classList.add('overlayActive');
      setIsHighlight(true);
    }
  };

  const removeHighlightElement = (targetID: string) => {
    const elem = document.getElementById(targetID);
    if (elem) {
      elem.classList.remove('overlayActive');
      elem.classList.remove('highlightActive');
      setIsHighlight(false);
    }
  };

  return {
    highlightElement,
    removeHighlightElement,
    isHighlight,
  };
};

export const usePreview = () => {
  const [isPreview, setIsPreview] = useState(false);

  const handlePreviewMode = () => {
    setIsPreview(!isPreview);
  };

  return [isPreview, handlePreviewMode];
};
